export default "__VITE_ASSET__e40WUy8$__"